<template lang="pug">
#mapa-leaflet(
    :style='{ height: height }',
    style='position: relative',
    :class='{ popupDeslocado: deslocarPopup }'
)
    div(
        :id='idMapa',
        :style='{ height: height }',
        v-observe-visibility='visibilityChanged'
    )
    button.btn(
        @click='finalizarEdicaoDeDesenho',
        v-if='alterandoGeometria',
        style='color: var(--primary); position: absolute; left: 45%; top: 90%; z-index: 1000'
    )
        i.mdi.mdi-check
        | {{ $t('mensagens.menuMapa.finalizarEdicaoDesenho') }}

    DrawerInspecionarCamadas(
        :show='mostrarDrawerInspecionar',
        :geometria='geometriaAcao',
        :camadas='camadasInspecao',
        :menuMaior='menuMaior',
        @fechar='fecharDrawerInspecionar'
    )

    .drawer-historico-agricola(v-if='mostrarDrawerHistoricoAgricola && mapa')
        DrawerHistoricoAgricola(
            :show='mostrarDrawerHistoricoAgricola',
            :geometria='geometriaAcao',
            :featureGroup='featureGroup',
            :mapa='mapa',
            @drawerHistoricoAgricolaFechar='drawerHistoricoAgricolaFechar'
        )

    .selecionar-camadas
        ModalSelecionarCamadas(
            :show='mostrarModalSelecionarCamadas',
            :camadasInspecao='camadasInspecao',
            @fechar='mostrarModalSelecionarCamadas = false',
            @inspecionar='inspecionar'
        )

    .enviar-diagnostico
        ModalEnviarGeometriaDiagnostico(
            :show='mostrarModalEnviarGeometriaDiagnostico',
            :geometria='geometriaAcao',
            @fechar='mostrarModalEnviarGeometriaDiagnostico = false'
        )
    DrawerMenuFerramentas(
        :show='ativarMenuFerramentas',
        :menuMaior='menuMaior',
        :mapConfigControls='mapConfig.controls',
        :limparMenuFerramentasAtivo='limparMenuFerramentasAtivo',
        :mapa='mapa || {}',
        @fixaZoom='fixaZoom',
        @adicionarAnotacao='adicionarAnotacao',
        :dadosDaAnotacaoEdicao='dadosDaAnotacaoEdicao',
        @dadosFormCoodernadas='dadosFormCoodernadas',
        @createMarkerOnClick='createMarkerOnClick',
        @closeDrawerMenuFerramentas='toggleMenuFerramentas',
        @resetarLimparMenuFerramentasAtivo='limparMenuFerramentasAtivo = false',
        @showPopupAcoes='showPopupAcoes'
    )
    DrawerMenuArea(
        :show='ativarMenuArea',
        :menuMaior='menuMaior',
        :mapConfigControls='mapConfig.controls',
        :limparMenuAreaAtivo='limparMenuAreaAtivo',
        @rulerActivate='rulerActivate',
        @drawControlCalc='drawControlCalc',
        @closeDrawerMenuArea='toggleMenuArea',
        @resetarLimparMenuAreaAtivo='limparMenuAreaAtivo = false'
    )
    DrawerMenuBuscaFinca(
        :show='ativarMenuBuscaFinca && mapa',
        :menuMaior='menuMaior',
        v-if='mapa',
        :mapa='mapa',
        @closeDrawerMenuBuscaFinca='toggleMenuBuscaFinca'
    )
    DrawerMenuCamadas(
        :show='ativarMenuCamadas',
        :menuMaior='menuMaior',
        :mapa='mapa || {}',
        :showStatesLayers='showStatesLayers',
        :limparMenuCamadasAtivo='limparMenuCamadasAtivo',
        @closeDrawerMenuCamadas='toggleMenuCamadas',
        @resetarLimparMenuCamadasAtivo='limparMenuCamadasAtivo = false',
        @atualizarListaCamadasModalInspecionar='atualizarListaCamadasModalInspecionar'
    )
    FerramentasSentinelHub(
        :show='ativarFerramentasSentinelHub',
        :menuMaior='menuMaior',
        :mapConfigControls='mapConfig.controls',
        :mapa='mapa',
        :selectorIdMapa='selectorIdMapa',
        @closeFerramentasSentinelHub='toggleFerramentasSentinelHub',
        @resetarLimparMenuFerramentasAtivo='limparMenuFerramentasAtivo = false'
    )
</template>

<script>
import L from 'leaflet';
import 'leaflet-easybutton';
import 'leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-easybutton/src/easy-button.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/leaflet.markercluster-src';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.js';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.css';
import 'leaflet-contextmenu';
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css';
import 'leaflet-measure-path';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.js';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.css';

import LayerStyles from '@/utils/layerStyles';

import Buffer from '@/components/mapa/buffer/Buffer.vue';
import BuscaCar from '@/components/mapa/buscaCar/BuscaCar.vue';
import ModalCoordenadas from './mapa/popup/ModalCoordenadas.vue';
import CamadasBase from '@/components/mapa/camadasBase/CamadasBase.vue';
import Popup from '@/components/mapa/camadas/PopupCarSelecionadoNoMapaTerritorio.vue';
import ControleLeafletComComponenteVue from '@/utils/mapa/ControleLeafletComComponenteVue';
import EventBus from '@/utils/eventBus';
import geometryUtils from '@/utils/mapa/geometry.js';

import UtilsService from '@/services/UtilsService';

import mapaEstilos, { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import {
    DEFAULT_CONFIG,
    BASE_LAYERS_CONFIG,
    TILE_LAYER_CONFIG,
    DEFAULT_CONFIG_PARAGUAY,
    DEFAULT_CONFIG_ARGENTINA,
    URL_KML_DOWNLOAD
} from '@/utils/mapa/mapa.config';

import '@/utils/mapa/mapa.draw.config.js';

import i18n from '@/main';

import { toDecimal } from 'geolib';
import IMask from 'imask';

import OptionsRuler from '@/constants/OptionsRuler';
import DrawCalc from '@/constants/DrawCalc';
import Utm from 'geodesy/utm';

import DrawerInspecionarCamadas from '@/components/DrawerInspecionarCamadas';
import DrawerHistoricoAgricola from '@/components/DrawerHistoricoAgricola';
import ModalSelecionarCamadas from '@/components/ModalSelecionarCamadas';
import ModalEnviarGeometriaDiagnostico from '@/components/_ModalEnviarGeometriaDiagnostico';
import DrawerMenuFerramentas from '@/components/DrawerMenuFerramentas';
import DrawerMenuArea from '@/components/DrawerMenuArea';
import DrawerMenuBuscaFinca from '@/components/DrawerMenuBuscaFinca';
import DrawerMenuCamadas from '@/components/DrawerMenuCamadas';
import FerramentasSentinelHub from '@/components/sentinelHub/FerramentasSentinelHub';

import { mapActions, mapState } from 'vuex';
import { sortBy } from 'lodash';

import ModalAnotacao from '@/components/mapa/popup/ModalAnotacao';
import { TipoAcaoGeometriaDesenhada } from '@/constants/TipoAcaoGeometriaDesenhada';

import { uuid } from 'vue-uuid';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'Mapa',

    components: {
        DrawerInspecionarCamadas,
        ModalSelecionarCamadas,
        DrawerHistoricoAgricola,
        ModalEnviarGeometriaDiagnostico,
        ModalCoordenadas,
        ModalAnotacao,
        DrawerMenuFerramentas,
        DrawerMenuArea,
        DrawerMenuBuscaFinca,
        DrawerMenuCamadas,
        FerramentasSentinelHub
    },

    props: {
        height: {
            required: false,
            type: String,
            default: '100%'
        },

        mapConfig: {
            required: false,
            type: Object
        },

        mapLayersConfigs: {
            required: false,
            type: Array
        },

        locked: {
            required: false,
            type: Boolean,
            default: false
        },

        idMapa: {
            required: true,
            type: String
        },

        deslocarPopup: {
            type: Boolean,
            required: false,
            default: false
        },

        showStatesLayers: {
            type: Boolean,
            required: false,
            default: true
        },

        camadaCentralizadaNome: {
            type: String,
            required: false
        },

        atualizarMapa: {
            type: Boolean,
            required: false,
            default: true
        },

        cluster: {
            type: Boolean,
            required: false,
            default: true
        },

        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },

        doubleMapOnPage: {
            type: Boolean,
            required: false,
            default: false
        },

        cadastroTerritorio: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            mapa: null,
            config: {},
            featureGroup: null,
            mapLayers: null,
            imageLayer: null,
            alterandoGeometria: false,
            popupDeslocado: 'popup-deslocado',
            drawMarker: null,
            markerTipo: 'decimal',
            mostrarDrawerInspecionar: false,
            mostrarDrawerHistoricoAgricola: false,
            coordenadas: {},
            mostrarModalSelecionarCamadas: false,
            camadasInspecao: [],
            geometriaAcao: {},
            renderComponente: false,
            camadas: [],
            mostrarModalEnviarGeometriaDiagnostico: false,
            drawMarkerAnotacao: null,
            desabilitaZoom: false,
            dadosDaAnotacao: null,
            dadosDaAnotacaoEdicao: null,
            comentarioEmEdicao: false,
            menuLateralIsOpen: false,
            fullscreenAtivado: false,
            selectorIdMapa: '',
            buscarCarIsOpen: false,
            uploadFileIsOpen: false,
            imagensSentinelIsOpen: false,
            layerSelecionadaZoom: null,
            fecharCaminhoMedir: true,
            ativarMenuFerramentas: false,
            ativarMenuArea: false,
            ativarMenuBuscaFinca: false,
            ativarFerramentasSentinelHub: false,
            limparMenuFerramentasAtivo: false,
            limparMenuAreaAtivo: false,
            ativarMenuCamadas: false,
            limparMenuCamadasAtivo: false,
            drawPolygon: null,
            geometrias: [],
            targetGeometry: null,
            editando: false,
            ambientes: AmbientesEmpresas,
            mostrarTooltipDownload: true,
            camadasAtivas: []
        };
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    mounted() {
        this.initializeComponent();
        this.config = Object.assign(DEFAULT_CONFIG, this.mapConfig);

        if (!this.mapa) {
            this.createMap();
        }

        EventBus.$off('retorna-geometria-car'); // finaliza o evento emitidos em outras páginas
        EventBus.$on('retorna-geometria-car', this.showPopupAcoes);
        this.$root.$on('remove-map-layer', this.removerDesenho);

        this.addEscListener();
        this.rightClickListener();
    },

    watch: {
        '$i18n.locale': function (newLocale) {
            this.reloadComponent();
        },

        mapLayersConfigs: {
            handler(val) {
                if (val.length > 0) {
                    this.clearLayers();
                }
                if (this.mapLayersConfigs.length === 0) {
                    this.clearLayers();
                    this.centralize();
                    this.limparLayerSelecionadaZoom();
                    this.limparAreaAgricultavelLayerSelecionadaZoom();
                } else {
                    if (
                        (val && val[0] && val[0].featureGroup) ||
                        !this.cluster
                    ) {
                        this.addMapLayerWithoutCluster();
                    } else {
                        this.addMapLayers();
                    }
                }
                if (val.length === 1 || this.atualizarMapa) {
                    this.refreshMap();
                }
            },
            deep: true
        },

        mapConfig: function () {
            this.addMapControls();
        },

        camadaCentralizadaNome: function () {
            if (this.atualizarMapa) {
                this.centralize();
            }
        },

        mostrarDrawerInspecionar(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuCamadas(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuFerramentas(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                if (!this.desabilitaZoom) {
                    this.changeMapInteractiveDrawers(false);
                }
            }
        },

        ativarMenuArea(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuBuscaFinca(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarFerramentasSentinelHub(val) {
            if (val) {
                this.$store.dispatch('processarEventoGoogleAnalytics', {
                    eventLabel: 'ATIVAR_MENU_SENTINEL_HUB',
                    pageTitle: 'ATIVAR_MENU_SENTINEL_HUB',
                    routeName: this.$route?.name,
                    routePath: this.$route?.path
                });
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        }
    },

    methods: {
        checkCamadasBaixaveis(camadasAtivas) {
            const camadasNaoBaixaveis = ['TREE_CANOPY_COVER_TCC'];
            return (
                camadasAtivas.length !== 1 ||
                camadasNaoBaixaveis.includes(camadasAtivas[0]?.codigo)
            );
        },

        reloadComponent() {
            if (this.mapa) {
                // this.mapa.remove();
                // this.mapa = null;
            }
            this.initializeComponent();
        },

        initializeComponent() {
            this.selectorIdMapa = `#${this.idMapa}`;
            this.config = Object.assign(DEFAULT_CONFIG, this.mapConfig);

            if (!this.mapa) {
                this.createMap();
            }

            this.clearEvents();

            this.addEscListener();

            this.handleFullscreenClick();

            this.handleClickOutsideMenus();
        },

        ...mapActions(['setGeometriaDesenhadaAcao', 'setAcaoEscolhida']),

        handleFullscreenClick() {
            if (this.mapConfig.controls.fullscreen) {
                const vm = this;
                var fullScreenButton = document.querySelector(
                    vm.selectorIdMapa + ' .leaflet-control-fullscreen-button'
                );

                fullScreenButton.setAttribute(
                    'title',
                    this.$t('mensagens.menuMapa.iconesFerramentas.telacheia')
                );

                fullScreenButton.addEventListener('click', function () {
                    vm.fullscreenAtivado = !vm.fullscreenAtivado;

                    setTimeout(() => {
                        if (vm.ativarMenuFerramentas && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-ferramentas'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-ferramentas')
                                );
                            }
                            vm.handleModalAnotacaoInputsOnFullscreen();
                        }

                        if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-area'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-area')
                                );
                            }
                        }

                        if (vm.ativarMenuBuscaFinca && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-busca-finca'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-busca-finca')
                                );
                            }
                        }

                        if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-camadas'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-camadas')
                                );
                            }
                        }

                        if (
                            vm.ativarFerramentasSentinelHub &&
                            vm.fullscreenAtivado
                        ) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#ferramentas-sentinel'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#ferramentas-sentinel')
                                );
                            }
                            vm.handleSentinelInputsOnFullscreen();
                        }
                    }, 150);
                });
            }
        },

        handleClickOutsideMenus() {
            const vm = this;
            setTimeout(() => {
                window.onclick = function (event) {
                    let elDrawerCamadas;
                    let elDrawerFerramentas;
                    let elDrawerArea;
                    let elDrawerBuscaFinca;
                    let elDrawerSentinelHub;
                    let elDrawerInspecionarCamadas;

                    if (vm.doubleMapOnPage) {
                        elDrawerCamadas = document.querySelectorAll(
                            '#drawer-menu-camadas .el-drawer'
                        )[1];
                        elDrawerFerramentas = document.querySelectorAll(
                            '#drawer-menu-ferramentas .el-drawer'
                        )[1];
                        elDrawerArea = document.querySelectorAll(
                            '#drawer-menu-area .el-drawer'
                        )[1];
                        elDrawerBuscaFinca = document.querySelectorAll(
                            '#drawer-menu-busca-finca .el-drawer'
                        )[1];
                        elDrawerSentinelHub = document.querySelectorAll(
                            '#ferramentas-sentinel .el-drawer'
                        )[1];
                        elDrawerInspecionarCamadas = document.querySelectorAll(
                            '#drawer-inspecionar-camadas .el-drawer'
                        )[1];
                    } else {
                        elDrawerCamadas = document.querySelectorAll(
                            '#drawer-menu-camadas .el-drawer'
                        )[0];
                        elDrawerFerramentas = document.querySelectorAll(
                            '#drawer-menu-ferramentas .el-drawer'
                        )[0];
                        elDrawerArea = document.querySelectorAll(
                            '#drawer-menu-area .el-drawer'
                        )[0];
                        elDrawerBuscaFinca = document.querySelectorAll(
                            '#drawer-menu-busca-finca .el-drawer'
                        )[1];
                        elDrawerSentinelHub = document.querySelectorAll(
                            '#ferramentas-sentinel .el-drawer'
                        )[0];
                        elDrawerInspecionarCamadas = document.querySelectorAll(
                            '#drawer-inspecionar-camadas .el-drawer'
                        )[0];
                    }

                    if (
                        event.target.contains(elDrawerCamadas) &&
                        event.target !== elDrawerCamadas
                    ) {
                        if (vm.ativarMenuCamadas) {
                            vm.toggleMenuCamadas();
                        }
                    }

                    if (
                        event.target.contains(elDrawerFerramentas) &&
                        event.target !== elDrawerFerramentas
                    ) {
                        if (vm.ativarMenuFerramentas) {
                            vm.toggleMenuFerramentas();
                        }
                    }

                    if (
                        event.target.contains(elDrawerArea) &&
                        event.target !== elDrawerArea
                    ) {
                        if (vm.ativarMenuArea) {
                            vm.toggleMenuArea();
                        }
                    }

                    if (
                        event.target.contains(elDrawerBuscaFinca) &&
                        event.target !== elDrawerBuscaFinca
                    ) {
                        if (vm.ativarMenuBuscaFinca) {
                            vm.toggleMenuBuscaFinca();
                        }
                    }

                    if (
                        event.target.contains(elDrawerInspecionarCamadas) &&
                        event.target !== elDrawerInspecionarCamadas
                    ) {
                        if (vm.mostrarDrawerInspecionar) {
                            vm.fecharDrawerInspecionar();
                        }
                    }

                    if (
                        event.target.contains(elDrawerSentinelHub) &&
                        event.target !== elDrawerSentinelHub
                    ) {
                        if (vm.ativarFerramentasSentinelHub) {
                            vm.toggleFerramentasSentinelHub();
                            setTimeout(() => {
                                $(
                                    vm.selectorIdMapa + ' .leaflet-top'
                                ).removeClass('fullscreen-ativado');
                            }, 10);
                        }
                    }
                };
            }, 200);
        },

        clearEvents() {
            EventBus.$off('retorna-geometria-car');
            EventBus.$on('retorna-geometria-car', this.showPopupAcoes);
            this.$root.$on('remove-map-layer', this.removerDesenho);
        },

        finalizarEdicaoDeDesenho() {
            var editedLayers = L.markerClusterGroup();
            this.featureGroup.eachLayer(layer => {
                if (layer.edited) {
                    editedLayers.addLayer(layer);
                    layer.edited = false;
                    layer.editing.disable();
                }
            });
            this.alterandoGeometria = false;
            this.$emit('draw-edited', editedLayers);
        },

        alterarGeometria(event) {
            event.target.editing.enable();
            this.alterandoGeometria = true;
        },

        visibilityChanged() {
            this.refreshMap();
        },

        createMap() {
            L.drawLocal = {
                draw: {
                    handlers: {
                        polygon: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaDesenharPoligono'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaContinuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.cliquePrimeiroPontoParaTerminar'
                                )
                            }
                        },
                        polyline: {
                            error: i18n?.t(
                                'mensagens.menuMapa.erro.arestasNaoPodemCruzar'
                            ),
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.desenharLinha'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        },
                        marker: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.inserirMarcador'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        }
                    }
                }
            };

            L.Map.include({
                _initControlPos: function () {
                    const corners = (this._controlCorners = {});
                    const container = (this._controlContainer =
                        L.DomUtil.create(
                            'div',
                            'leaflet-control-container',
                            this._container
                        ));

                    function createCorner(vSide, hSide) {
                        const className = `leaflet-${vSide} leaflet-${hSide}`;

                        corners[vSide + hSide] = L.DomUtil.create(
                            'div',
                            className,
                            container
                        );
                    }

                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);

                    createCorner('top', 'left');
                    createCorner('top', 'right');
                    createCorner('bottom', 'left');
                    createCorner('bottom', 'right');
                    createCorner('top', 'center');
                    createCorner('middle', 'center');
                    createCorner('middle', 'left');
                    createCorner('middle', 'right');
                    createCorner('bottom', 'center');
                }
            });

            const menuOptions = [{ text: 'Inspecionar' }];

            this.mapa = L.map(this.idMapa, {
                contextmenu: this.mapConfig.inspecionar,
                contextmenuWidth: 190,
                contextmenuItems: menuOptions,
                ...this.config,
                maxZoom: 17
            });

            this.featureGroup = L.markerClusterGroup();

            this.featureGroup.addTo(this.mapa);

            L.tileLayer(TILE_LAYER_CONFIG.url, {
                attribution: TILE_LAYER_CONFIG.attribution
            }).addTo(this.mapa);

            if (this.permissaoAmbiente(this.ambientes.PARAGUAY)) {
                this.mapa.setView([-23.447949, -58.452454], 6); // Definindo o centro e o zoom do mapa
            }

            if (!this.locked) {
                this.addMapControls();
            }

            if (!_.isEmpty(this.mapLayersConfigs)) {
                this.addMapLayers();
            }

            this.changeMapInteractive();

            const self = this;

            this.mapa.on(L.Draw.Event.CREATED, e => {
                if (self.dadosDaAnotacao === null) {
                    let layer = e.layer;
                    layer.layerType = e.layerType;

                    this.showPopupAcoes(layer);
                }
            });

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll('#drawer-menu-camadas')[1]
                );
            } else {
                $(this.selectorIdMapa).prepend($('#drawer-menu-camadas'));
            }

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll('#drawer-menu-ferramentas')[1]
                );
            } else {
                $(this.selectorIdMapa).prepend($('#drawer-menu-ferramentas'));
            }

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll('#drawer-menu-area')[1]
                );
            } else {
                $(this.selectorIdMapa).prepend($('#drawer-menu-area'));
            }

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll('#ferramentas-sentinel')[1]
                );
            } else {
                $(this.selectorIdMapa).prepend($('#ferramentas-sentinel'));
            }
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        createContextMenu(point) {
            const camadasAtivas = [];
            this.camadasAtivas.forEach(camada => {
                if (camada && camada.layerName) {
                    camadasAtivas.push(camada);
                }
            });

            const mapasDisponiveis = [
                'MapaSig',
                'mapaDiagnosticoSocioambiental',
                'mapaAddTerritorio'
            ];
            this.mapa.contextmenu.removeAllItems();
            this.mapa.contextmenu.addItem({
                text: this.$t('mensagens.menuMapa.inspecionar'),
                callback: this.selecionarCamadas,
                icon: 'https://lyra-v1.s3.amazonaws.com/mdi_inspecionar_white.png'
            });
            mapasDisponiveis.includes(this.idMapa) &&
                this.mapa.contextmenu.addItem({
                    text: this.$t('mensagens.menuMapa.downloadPoligono'),
                    callback: () =>
                        this.downloadCamadas(
                            point,
                            this.camadasAtivas[0].layerName
                        ),
                    icon: 'https://lyra-v1.s3.amazonaws.com/mdi_download_white.png',
                    disabled: this.checkCamadasBaixaveis(camadasAtivas)
                });
        },

        addMapLayers() {
            if (!this.featureGroup) this.featureGroup = L.markerClusterGroup();

            this.mapLayers = {};

            this.mapLayersConfigs.forEach(layerConfig => {
                if (!layerConfig.geoJson) {
                    return;
                }

                let geometry = null;

                if (
                    layerConfig.geoJson.type === 'Point' ||
                    layerConfig.geoJson.type === 'MultiPoint'
                ) {
                    geometry = this.addPointLayer(layerConfig);
                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                } else {
                    geometry = L.geoJSON(
                        layerConfig.geoJson,
                        layerConfig.style
                    );

                    if (layerConfig.tooltip) {
                        geometry.bindTooltip(layerConfig.tooltip);
                    }

                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                }

                if (layerConfig.geoJson.type !== 'MultiPoint') {
                    geometry._layers[geometry._leaflet_id - 1].name =
                        layerConfig.name;
                    geometry._layers[geometry._leaflet_id - 1].group =
                        layerConfig.group;
                }

                this.featureGroup.addLayer(geometry);
            });

            if (!this.mapa.hasLayer(this.featureGroup)) {
                this.featureGroup.addTo(this.mapa);
            }

            if (this.atualizarMapa) {
                this.refreshMap();
            }
        },

        addMapLayerWithoutCluster() {
            const featureGroupGeometry = [];

            this.mapLayersConfigs.forEach(layerConfig => {
                if (!layerConfig.geoJson) {
                    return;
                }

                let geometry = null;

                if (
                    layerConfig.geoJson.type === 'Point' ||
                    layerConfig.geoJson.type === 'MultiPoint'
                ) {
                    geometry = this.addPointLayer(layerConfig);
                    featureGroupGeometry.push(geometry);
                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                } else {
                    geometry = L.geoJSON(
                        layerConfig.geoJson,
                        layerConfig.style
                    );

                    if (layerConfig.tooltip) {
                        geometry.bindTooltip(layerConfig.tooltip);
                    }

                    if (layerConfig.popup) {
                        geometry.bindPopup(layerConfig.popup);
                    }
                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                    geometry._layers[geometry._leaflet_id - 1].name =
                        layerConfig.name;
                    geometry._layers[geometry._leaflet_id - 1].group =
                        layerConfig.group;

                    featureGroupGeometry.push(geometry);
                }
            });

            this.featureGroup = L.featureGroup(featureGroupGeometry);

            if (!this.mapa.hasLayer(this.featureGroup)) {
                this.featureGroup.addTo(this.mapa);
            }

            if (this.atualizarMapa) {
                this.refreshMap();
            }
        },

        addEscListener() {
            const vm = this;
            $(document).bind(
                'fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange',
                function (e) {
                    var fullscreenElement =
                        document.fullscreenElement ||
                        document.webkitFullscreenElement ||
                        document.mozFullscreenElement ||
                        document.msFullscreenElement;

                    if (!fullscreenElement) {
                        vm.fullscreenAtivado = !vm.fullscreenAtivado;

                        if (vm.ativarMenuFerramentas && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-ferramentas'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-ferramentas')
                                );
                            }
                            vm.handleModalAnotacaoInputsOnFullscreen();
                        }

                        if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-area'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-area')
                                );
                            }
                        }

                        if (vm.ativarMenuBuscaFinca && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-busca-finca'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-busca-finca')
                                );
                            }
                        }

                        if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-camadas'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-camadas')
                                );
                            }
                        }

                        if (
                            vm.ativarFerramentasSentinelHub &&
                            vm.fullscreenAtivado
                        ) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#ferramentas-sentinel'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#ferramentas-sentinel')
                                );
                            }
                            vm.handleSentinelInputsOnFullscreen();
                        }
                    }
                }
            );

            document.addEventListener('keyup', e => {
                if (e.keyCode === 27) {
                    $(
                        vm.selectorIdMapa +
                        ' .leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    $(
                        vm.selectorIdMapa + ' .leaflet-interactive.drawCalc'
                    ).removeClass('active');
                    $(
                        vm.selectorIdMapa + ' .leaflet-interactive.draw'
                    ).removeClass('active');
                }
            });
        },

        rightClickListener() {
            this.mapa.on('contextmenu', event => {
                this.createContextMenu(event.latlng);
                this.downloadPoligonoHoverListener();
            });
        },

        downloadPoligonoHoverListener() {
            const botaoDownload = document.getElementsByClassName(
                'leaflet-contextmenu-item-disabled'
            );

            for (let i = 0; i < botaoDownload.length; i++) {
                if (this.mostrarTooltipDownload) {
                    botaoDownload[i].addEventListener(
                        'mouseenter',
                        function (e) {
                            this.mostrarTooltipDownload = false;
                            const containerTooltip =
                                document.createElement('div');
                            containerTooltip.setAttribute(
                                'id',
                                'tooltip-download-indisponivel'
                            );
                            const textoTooltip = document.createElement('p');
                            textoTooltip.innerText =
                                'É possível realizar o download quando apenas uma camada estiver selecionada, e quando a camada pode ser baixada.';
                            containerTooltip.appendChild(textoTooltip);
                            botaoDownload[i].appendChild(containerTooltip);
                        }
                    );
                    botaoDownload[i].addEventListener(
                        'mouseleave',
                        function (e) {
                            this.mostrarTooltipDownload = true;
                            const element = document.getElementById(
                                'tooltip-download-indisponivel'
                            );
                            element.remove();
                        }
                    );
                }
            }
        },

        addMapControls() {
            this.zoomControl();
            this.centralizeControl();

            if (this.mapConfig.controls.popupControl) {
                this.popupControl();
            }
            if (this.mapConfig.controls.fullscreen) {
                this.fullscreenControl();
            }
            if (this.permissaoAmbiente(this.ambientes.BRASIL)) {
                this.addBuscaCarControl();
            }
            if (this.permissaoAmbiente(this.ambientes.PARAGUAY)) {
                this.addBotaoBuscaFinca();
            }
            if (this.mapConfig.controls.camadasControl) {
                this.camadasControl();
            }
            if (this.usuarioLogado.sentinelHubAccess) {
                this.addBotaoSentinelHub(this.cadastroTerritorio);
            }
            if (this.mapConfig.controls.ferramentasControl !== false) {
                this.addBotaoFerramentas();
            }
            this.addBotaoArea();
            this.rulerControl();
            if (
                this.mapConfig.controls.bufferControl === undefined ||
                this.mapConfig.controls.bufferControl
            ) {
                this.addBufferControl();
            }

            L.control
                .coordinates({
                    position: 'bottomcenter',
                    decimals: 10,
                    decimalSeperator: '.',
                    labelTemplateLat: 'Latitude: {y}',
                    labelTemplateLng: 'Longitude: {x}',
                    enableUserInput: false,
                    useDMS: false,
                    useLatLngOrder: false,
                    centerUserCoordinates: true,
                    markerType: L.marker,
                    markerProps: {}
                })
                .addTo(this.mapa);

            this.markerControl();

            if (this.mapConfig.controls.camadasBaseControl) {
                this.camadasBaseControl();
            }

            if (this.mapConfig.controls.drawControl) {
                this.drawControl();
            }
        },

        addMapPopupControls() {
            if (this.mapConfig.controls.popupControl) {
                this.popupControl();
            } else {
                this.refreshMap();
                document.getElementById('popup').style.display = 'none';
            }
        },

        zoomControl(zoom) {
            L.control
                .zoom({
                    position: 'topright',
                    zoomControl: false
                })
                .addTo(this.mapa);
        },

        fixaControl() {
            L.easyButton({
                id: 'botao-fixar-zoom',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: btn => this.fixaZoom(btn),
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.fixarZoom'
                        ),
                        icon: 'mdi mdi-pin'
                    }
                ]
            }).addTo(this.mapa);
        },

        centralizeControl() {
            L.easyButton({
                id: 'botao-centralizar-zoom',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.centralize(),
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.centralizar'
                        ),
                        icon: 'mdi mdi-crosshairs-gps'
                    }
                ]
            }).addTo(this.mapa);
        },

        rulerControl() {
            L.control.ruler(OptionsRuler.DEFAULT).addTo(this.mapa);
            $(
                this.selectorIdMapa +
                ' .leaflet-bar.leaflet-ruler.leaflet-control'
            ).addClass('none');
        },

        rulerActivate() {
            setTimeout(() => {
                $(
                    this.selectorIdMapa +
                    ' .leaflet-bar.leaflet-ruler.leaflet-control'
                ).click();
            }, 200);
        },

        drawControl() {
            const polyOptions = {
                allowIntersection: false,
                drawError: {
                    color: '#e1e100',
                    message:
                        '<strong>As arestas do polígono não devem se cruzar</strong>'
                },
                shapeOptions: {
                    color: '#bada55',
                    showMeasurements: false
                },
                icon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                }),
                touchIcon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                })
            };

            this.drawPolygon = new L.Draw.Polygon(this.mapa, polyOptions);
            document.addEventListener(
                'keydown',
                function (event) {
                    if (event.key === 'Escape' && this.drawPolygon.enabled()) {
                        this.emitEventsTerritorio();
                        this.drawPolygon.disable();
                        $(
                            this.selectorIdMapa + ' .leaflet-interactive.draw'
                        ).removeClass('active');
                    }
                }.bind(this)
            );
            L.easyButton({
                id: 'botao-desenhar',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.draw(),
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.desenhar'
                        ),
                        icon: 'mdi mdi-pencil-outline'
                    }
                ]
            }).addTo(this.mapa);

            $(
                this.selectorIdMapa +
                ` .leaflet-interactive[title="${this.$t(
                    'mensagens.menuMapa.iconesFerramentas.desenhar'
                )}"]`
            ).addClass('draw');
        },

        drawControlCalc() {
            const polyOptionsCalc = DrawCalc.OPTIONS;

            this.drawPolygonCalc = new L.Draw.Polygon(
                this.mapa,
                polyOptionsCalc
            );

            this.drawCalc();
        },

        addBufferControl() {
            const config = {
                classeControle: 'leaflet-control-buffer',
                position: 'bottomcenter'
            };
            ControleLeafletComComponenteVue(
                Buffer,
                this.mapa,
                {},
                config,
                i18n
            );
        },

        addBuscaCarControl() {
            const config = {
                classeControle: 'leaflet-control-busca-car',
                position: 'topright'
            };

            ControleLeafletComComponenteVue(
                BuscaCar,
                this.mapa,
                { mapa: this.mapa },
                config,
                i18n
            );
        },

        camadasBaseControl() {
            const configCamadas = BASE_LAYERS_CONFIG;

            const config = {
                classeControle: 'leaflet-control-camadas-base',
                position: 'bottomright'
            };
            ControleLeafletComComponenteVue(
                CamadasBase,
                this.mapa,
                { configCamadas },
                config,
                i18n
            );
        },

        camadasControl() {
            L.easyButton({
                id: 'botao-camadas',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-camadas',
                        onClick: this.toggleMenuCamadas,
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.camadas'
                        ),
                        icon: 'mdi mdi-layers-outline'
                    }
                ]
            }).addTo(this.mapa);
        },

        popupControl() {
            const config = {
                position: 'bottomright'
            };
            return ControleLeafletComComponenteVue(
                Popup,
                this.mapa,
                {},
                config,
                i18n
            );
        },

        addPointLayer(layerConfig) {
            const layer = L.geoJSON(layerConfig.geoJson, {
                pointToLayer: function (feature, latlng) {
                    let marker = layerConfig.icon
                        ? L.marker(latlng, { icon: layerConfig.icon })
                        : new L.CircleMarker(latlng, layerConfig.style);

                    if (layerConfig.tipoCultura) {
                        marker = layerConfig.icon
                            ? L.marker(latlng, { icon: layerConfig.icon })
                            : LayerStyles.MARKER(
                                layerConfig.tipoCultura,
                                latlng
                            );
                    }

                    if (layerConfig.popup) {
                        marker.bindPopup(layerConfig.popup);
                    }

                    if (layerConfig.tooltip) {
                        marker.bindTooltip(layerConfig.tooltip, {
                            direction: 'top'
                        });
                    }

                    if (layerConfig.acaoClick) {
                        marker.on('click', () => layerConfig.acaoClick());
                    }

                    return marker;
                }
            });

            return layer;
        },

        refreshMap() {
            this.mapa.invalidateSize();
            this.centralize();
        },

        fixaZoom(btn) {
            this.desabilitaZoom = !this.desabilitaZoom;
            if (this.desabilitaZoom) {
                this.mapa.scrollWheelZoom.disable();
                this.mapa.doubleClickZoom.disable();
                this.mapa.boxZoom.disable();
                this.mapa.touchZoom.disable();
                this.mapa.dragging.disable();
            } else {
                this.mapa.scrollWheelZoom.enable();
                this.mapa.doubleClickZoom.enable();
                this.mapa.boxZoom.enable();
                this.mapa.touchZoom.enable();
                this.mapa.dragging.enable();
                this.limparMenuFerramentasAtivo = true;
            }
        },

        centralize() {
            if (this.desabilitaZoom) return;
            if (
                (this.mapLayersConfigs && this.mapLayersConfigs.length > 0) ||
                (this.mapLayers &&
                    !_.isEmpty(this.mapLayers) &&
                    !this.config.dontZoomIn)
            ) {
                if (this.mapLayersConfigs && this.mapLayersConfigs.length > 0) {
                    if (this.featureGroup.getBounds().isValid()) {
                        this.mapa.fitBounds(this.featureGroup.getBounds(), {
                            maxZoom: 17
                        });
                    }
                } else {
                    if (this.featureGroup.getBounds().isValid()) {
                        this.mapa.fitBounds(this.featureGroup.getBounds(), {
                            maxZoom: 5
                        });
                    }
                }
            } else {
                if (this.mapa) {
                    if (this.permissaoAmbiente(this.ambientes.PARAGUAY)) {
                        this.mapa.setView(
                            DEFAULT_CONFIG_PARAGUAY.center,
                            DEFAULT_CONFIG_PARAGUAY.zoom
                        );
                    }
                    if (this.permissaoAmbiente(this.ambientes.ARGENTINA)) {
                        this.mapa.setView(
                            DEFAULT_CONFIG_ARGENTINA.center,
                            DEFAULT_CONFIG_ARGENTINA.zoom
                        );
                    } else {
                        this.mapa.setView(
                            DEFAULT_CONFIG.center,
                            DEFAULT_CONFIG.zoom
                        );
                    }
                }
            }
            this.leafletClassesFixamapa = false;
        },

        clearLayers() {
            if (this.featureGroup) {
                this.featureGroup.clearLayers();
            }
        },

        limparLayerSelecionadaZoom() {
            if (this.layerSelecionadaZoom) {
                this.mapa.removeLayer(this.layerSelecionadaZoom);
                this.layerSelecionadaZoom = null;
            }
        },

        limparAreaAgricultavelLayerSelecionadaZoom() {
            for (let geometria of this.geometrias) {
                this.mapa.removeLayer(geometria);
            }
            this.geometrias = [];
        },

        changeMapInteractive() {
            let lockFunc = 'enable';
            if (this.locked) {
                lockFunc = 'disable';
            }

            this.mapa.dragging[lockFunc]();
            this.mapa.touchZoom[lockFunc]();
            this.mapa.doubleClickZoom[lockFunc]();
            this.mapa.scrollWheelZoom[lockFunc]();
            this.mapa.boxZoom[lockFunc]();
            this.mapa.keyboard[lockFunc]();

            if (this.mapa.tap) this.mapa.tap[lockFunc]();
        },

        changeMapInteractiveDrawers(lockInteractive) {
            let lockFunc = 'enable';
            if (lockInteractive) {
                lockFunc = 'disable';
            }

            this.mapa.dragging[lockFunc]();
            this.mapa.touchZoom[lockFunc]();
            this.mapa.doubleClickZoom[lockFunc]();
            this.mapa.scrollWheelZoom[lockFunc]();
            this.mapa.boxZoom[lockFunc]();
            this.mapa.keyboard[lockFunc]();

            if (this.mapa.tap) this.mapa.tap[lockFunc]();
        },

        ativarDesativarCamadasPorNome(layers) {
            layers.forEach(layer => {
                if (layer) {
                    const existeArea = this.mapLayersConfigs.find(
                        m => m.name === layer.name
                    );
                    if (existeArea) {
                        this.mapLayersConfigs = this.mapLayersConfigs.filter(
                            m => m.name !== layer.name
                        );
                    } else {
                        this.mapLayersConfigs.push(layer);
                    }
                }
            });
        },

        fullscreenControl() {
            this.mapa.addControl(
                new L.Control.Fullscreen({
                    position: 'topright'
                })
            );
        },

        draw() {
            this.emitEventsTerritorio();
            if (this.mapa.doubleClickZoom.enabled()) {
                if (!this.drawPolygon.enabled()) {
                    this.drawPolygon.enable();
                    $(
                        this.selectorIdMapa + ' .leaflet-interactive.draw'
                    ).addClass('active');
                } else {
                    this.drawPolygon.disable();
                    $(
                        this.selectorIdMapa + ' .leaflet-interactive.draw'
                    ).removeClass('active');
                }
            }
        },

        adicionarEventosComponenteCalcularArea() {
            this.mapa.on(L.Draw.Event.CREATED, e => {
                this.targetGeometry = e.layer;

                e.layer.on('click', () => {
                    this.targetGeometry = e.layer;
                });
            });

            this.mapa.on('keyup', event => {
                // Tecla Enter
                if (event.originalEvent.keyCode === 13) {
                    if (this.editando) {
                        this.desabilitarEdicao(this.targetGeometry);
                        this.editando = false;
                        this.showPopupAcoes(this.targetGeometry);
                    }
                }
            });
        },

        drawCalc() {
            this.closePopup();
            this.emitEventsTerritorio();
            if (!this.drawPolygonCalc.enabled()) {
                this.drawPolygonCalc.enable();
                $(
                    this.selectorIdMapa + ' .leaflet-interactive.drawCalc'
                ).addClass('active');
            } else {
                this.drawPolygonCalc.disable();
                $(
                    this.selectorIdMapa + ' .leaflet-interactive.drawCalc'
                ).removeClass('active');
            }
            this.adicionarEventosComponenteCalcularArea();
        },

        removerDesenho(identificadorGeometria) {
            let layerToRemove = null;

            layerToRemove = Object.values(this.mapa._layers).find(
                l => l.identificadorGeometria === identificadorGeometria
            );

            if (layerToRemove) {
                layerToRemove.removeFrom(this.mapa);
                return;
            }

            layerToRemove = this.featureGroup
                .getLayers()
                .find(l => l.identificadorGeometria === identificadorGeometria);

            if (layerToRemove) {
                this.featureGroup.removeLayer(layerToRemove);
                return;
            }

            Object.values(this.mapa._layers).forEach(l => {
                if (
                    l.feature &&
                    l.feature.geometry &&
                    l.feature.geometry.identificadorGeometria ===
                    identificadorGeometria
                ) {
                    layerToRemove = l;
                }
            });

            if (layerToRemove) {
                layerToRemove.removeFrom(this.mapa);
            }
        },

        markerControl() {
            $(
                this.selectorIdMapa +
                ` .leaflet-interactive.marker-active[title="${this.$t(
                    'mensagens.menuMapa.iconesFerramentas.cliqueParaMarcar'
                )}"]`
            ).addClass('marcador');

            let mapa = this.mapa;

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            this.drawMarker = new L.Draw.Marker(this.mapa, {
                icon: pinIcon,
                draggable: true
            });

            const self = this;

            this.mapa.on(L.Draw.Event.CREATED, e => {
                if (self.dadosDaAnotacao === null) {
                    let layer = e.layer;
                    layer.layerType = e.layerType;
                    this.showPopupAcoes(layer);
                }
            });

            this.mapa.on('popupopen', function (e) {
                let px = mapa.project(e.target._popup._latlng);
                px.y -= e.target._popup._container.clientHeight / 2;
                mapa.panTo(mapa.unproject(px), { animate: true });
                self.mudarTextoBotaoEditarDesenho(self);
            });
        },

        mudarTextoBotaoEditarDesenho(self) {
            const btn = document.getElementById('leaflat-btn-5-editar-desenho');

            if (btn && self.editando) {
                btn.innerHTML = self.$t('mensagens.menuMapa.finalizarEdicao');
            } else if (btn) {
                btn.innerHTML = self.$t('mensagens.menuMapa.editarDesenho');
            }
        },

        habilitarEdicao(layer) {
            this.targetGeometry = layer;

            layer.bindTooltip(
                `${this.$t('mensagens.menuSig.arrasteParaEditar')} </br> ` +
                `${this.$t(
                    'mensagens.menuSig.pressioneParafinalizarEdicao'
                )}`
            );
            layer.editing.enable();
            $('.leaflet-draw-edit-edit').addClass('active');
        },

        desabilitarEdicao(layer) {
            layer.unbindTooltip();
            layer.editing.disable();
            $('.leaflet-draw-edit-edit').removeClass('active');
        },

        toggleEditar() {
            if (
                this.targetGeometry &&
                this.targetGeometry.layerType === 'polygon'
            ) {
                if (this.editando) {
                    this.desabilitarEdicao(this.targetGeometry);
                } else {
                    this.habilitarEdicao(this.targetGeometry);
                }

                this.editando = !this.editando;
                this.closePopup();
                this.mudarTextoBotaoEditarDesenho(this);
                this.showPopupAcoes(this.targetGeometry);
            }
        },

        showPopupAcoes(layer) {
            let mapa = this.mapa;
            let layerPlanilha =
                layer.layerPlanilha !== undefined &&
                layer.layerPlanilha === true;
            if (layer.options.draggable !== true) {
                layer.options.draggable = true;
                this.featureGroup.addLayer(layer);
                this.$emit('draw-created', layer);
            }

            let acoes = [];

            if (this.mapConfig.inspecionar) {
                acoes.push({
                    id: 2,
                    botao: `<i class="el el-icon-search text-white"><span> ${this.$t(
                        'mensagens.menuMapa.inspecionar'
                    )}</span></i>`,
                    acao: () => {
                        this.geometriaAcao = layerPlanilha
                            ? layer.geometry
                            : layer.toGeoJSON().geometry;
                        this.mostrarModalSelecionarCamadas = true;
                        setTimeout(() => {
                            this.handleModalInspecionarCamadasFullscreen();
                        }, 100);
                    }
                });
            }

            if (
                this.mapConfig.diagnostico &&
                this.usuarioLogado.ambienteLogado !== 'AR'
            ) {
                acoes.push({
                    id: 3,
                    botao: `<i class="flow flow-environment text-white"><span> ${this.$t(
                        'mensagens.menuMapa.diagnostico'
                    )}</span></i>`,
                    acao: () => {
                        this.geometriaAcao = layerPlanilha
                            ? layer.geometry
                            : layer.toGeoJSON().geometry;

                        if (
                            this.$router.currentRoute.name ===
                            'DiagnosticoSocioambiental'
                        ) {
                            this.setGeometriaDesenhadaAcao(this.geometriaAcao);
                            this.setAcaoEscolhida({
                                acao: TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
                            });
                            this.$emit('diagnostico', this.geometriaAcao);
                        } else if (
                            this.$router.currentRoute.name ===
                            'DiagnosticosSocioambientais'
                        ) {
                            this.adicionarDiagnosticoSocioAmbientalListagem();
                        } else {
                            this.redirecionarParaDiagnostcosSocioAmbientais();
                        }
                    }
                });
            }

            if (this.mapConfig.editar) {
                acoes.push({
                    id: 5,
                    botao: `<i class="el el-icon-edit text-white"><span> ${this.$t(
                        'mensagens.menuMapa.editarDesenho'
                    )}</span></i>`,
                    acao: () => {
                        this.toggleEditar();
                    }
                });
            }

            if (layer?.layerType === 'polygon') {
                acoes.push({
                    id: 5,
                    botao: `
                        <i class="el el-icon-edit text-white">
                            <span id="leaflat-btn-5-editar-desenho">
                                ${this.$t('mensagens.menuMapa.editarDesenho')}
                            </span>
                        </i>`,
                    acao: () => {
                        this.toggleEditar();
                    }
                });
            }

            acoes.push({
                id: 6,
                botao: `<i class="el el-icon-delete text-white"><span> ${this.$t(
                    'mensagens.menuMapa.remover'
                )}</span></i>`,
                acao: () => {
                    this.$emit(
                        'removerTerritorio',
                        layer.identificadorGeometria
                    );
                    mapa.removeLayer(layer);
                }
            });

            const botaoHistoricoAgricola = {
                id: 1,
                botao: `<i class="flow flow-environment text-white"><span> ${this.$t(
                    'mensagens.menuMapa.historicoAgricola'
                )}</span></i>`,
                acao: () => {
                    this.geometriaAcao = layerPlanilha
                        ? layer.geometry
                        : layer.toGeoJSON().geometry;
                    this.mostrarDrawerHistoricoAgricola = true;
                    this.closePopup();
                }
            };

            const botaoDownloadKml = {
                id: 4,
                botao: `<i class="el el-icon-download text-white"><span> ${this.$t(
                    'mensagens.menuMapa.baixarPoligono'
                )}</span></i>`,
                acao: () => {
                    this.geometriaAcao = layerPlanilha
                        ? layer.geometry
                        : layer.toGeoJSON().geometry;
                    UtilsService.baixarKMLdeGeometria(this.geometriaAcao);
                    this.closePopup();
                }
            };

            if (
                this.usuarioLogado.historicoMonitoramentoAccess &&
                (this.mapConfig.historicoMonitoramento === undefined ||
                    this.mapConfig.historicoMonitoramento === true)
            ) {
                acoes.push(botaoHistoricoAgricola);
            }

            if (layer.layerType === 'polygon') {
                acoes.push(botaoDownloadKml);
            }

            acoes = sortBy(acoes, ['id']);

            const elMenu = document.createElement('div');
            elMenu.setAttribute('id', 'menu-popup-ponto');

            let areaHa;
            if (layerPlanilha) {
                areaHa = this.formatAreaHa(
                    geometryUtils.calcularAreaHaFromLayerPlanilha(layer)
                );
            } else {
                areaHa = this.formatAreaHa(
                    geometryUtils.calcularAreaHaFromLayer(layer)
                );
            }
            const areaInfo = document.createElement('p');
            if (layerPlanilha) {
                areaInfo.innerHTML = `${this.$t(
                    'mensagens.menuMapa.areaPoligono'
                )}<br>${areaHa} (ha)`;
            } else if (layer.toGeoJSON().geometry.type !== 'Point') {
                areaInfo.innerHTML = `${this.$t(
                    'mensagens.menuMapa.areaPoligono'
                )}<br>${areaHa} (ha)`;
            }

            acoes.forEach(({ id, botao, acao }) => {
                const elBtnAcao = document.createElement('a');
                elBtnAcao.classList.add('btn');
                elBtnAcao.classList.add('container-botoes-inspecionar');
                elBtnAcao.classList.add('btn');

                elBtnAcao.innerHTML = botao;
                elBtnAcao.href = 'javascript:void(0)';
                elBtnAcao.onclick = acao;

                elMenu.appendChild(elBtnAcao);
            });

            if (layer.layerType === 'marker') {
                const elLatLng = document.createElement('p');
                elLatLng.setAttribute('class', 'latlng-popup');
                elLatLng.innerHTML = `${this.$t(
                    'mensagens.menuMapa.latitude'
                )}: ${layer._latlng.lat.toFixed(4)} <br> ${this.$t(
                    'mensagens.menuMapa.longitude'
                )}: ${layer._latlng.lng.toFixed(4)}`;

                elMenu.appendChild(elLatLng);
                this.limparMenuFerramentasAtivo = true;
            }

            elMenu.appendChild(areaInfo);

            layer.bindPopup(elMenu, {
                maxWidth: 'auto'
            });

            switch (layer.layerType) {
                case 'marker':
                    $(
                        this.selectorIdMapa +
                        ' .leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    break;

                case 'polygon':
                    $(
                        this.selectorIdMapa + ' .leaflet-interactive.drawCalc'
                    ).removeClass('active');
                    $(
                        this.selectorIdMapa + ' .leaflet-interactive.draw'
                    ).removeClass('active');
                    break;
            }
        },

        showMarker(e) {
            let coordenadas = [this.config.center[0], this.config.center[1]];
            if (e.latlng !== undefined) {
                coordenadas[0] = e.latlng.lat;
                coordenadas[1] = e.latlng.lng;
            }

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            let marker = L.marker(coordenadas, {
                icon: pinIcon,
                draggable: true
            });
            this.mapa.addLayer(marker);

            let mapa = this.mapa;

            const elDiv = document.createElement('div');
            elDiv.className = 'divPopup';

            let elA = document.createElement('a');
            elA.className = 'btn btn-danger text-white removerMarcador';
            elA.innerHTML = `<i class="mdi mdi-delete-outline">${this.$t(
                'mensagens.menuMapa.remover'
            )}</i>`;
            elA.href = 'javascript:void(0)';
            elA.onclick = function () {
                mapa.removeLayer(marker);
            };

            const elLatLng = document.createElement('p');
            elLatLng.setAttribute('class', 'latlng-popup');
            elLatLng.innerHTML = `${this.$t(
                'mensagens.menuMapa.latitude'
            )}: ${parseFloat(e.latlng.lat).toFixed(4)}  ${this.$t(
                'mensagens.menuMapa.longitude'
            )}: ${parseFloat(e.latlng.lng).toFixed(4)}`;

            elDiv.appendChild(elA);

            elDiv.appendChild(elLatLng);

            marker.bindPopup(elDiv, {
                maxWidth: 'auto'
            });

            let px = mapa.project(marker.getLatLng());
            px.y -= marker.getPopup().getContent().clientHeight / 2;
            mapa.panTo(mapa.unproject(px), { animate: true });
        },

        dadosFormCoodernadas(dados) {
            let latitude = dados.latitude.completo;
            let longitude = dados.longitude.completo;

            if (dados.tipo === 'gms') {
                const input = {
                    lat: dados.latitude.completo,
                    lon: dados.longitude.completo
                };
                const decimalCoords = toDecimal(input);
                latitude = decimalCoords.lat;
                longitude = decimalCoords.lon;
            } else if (dados.tipo === 'utm') {
                const utmCoord =
                    dados.utm.fuso +
                    ' ' +
                    dados.utm.hemisferio.substring(0, 1) +
                    ' ' +
                    dados.utm.x +
                    ' ' +
                    dados.utm.y;
                const utm = Utm.parse(utmCoord);
                const coords = utm.toLatLon();
                latitude = coords.lat;
                longitude = coords.lng;
            }

            try {
                this.showMarker({
                    latlng: {
                        lat: latitude,
                        lng: longitude
                    }
                });

                this.closePopup();
            } catch (e) {
                this.$notify.info({
                    message: this.$t(
                        'mensagens.menuMapa.erro.naoFoiPossivelObterArea'
                    )
                });
            }
        },

        createMarkerOnClick() {
            this.closePopup();
            this.emitEventsTerritorio();
            if (!this.drawMarker.enabled()) {
                this.drawMarker.enable();
                $(
                    this.selectorIdMapa +
                    ' .leaflet-interactive.marker-active.marcador'
                ).addClass('active');
                $(
                    this.selectorIdMapa +
                    ' .leaflet-interactive.marker-active.marcador'
                ).attr(
                    'title',
                    `${this.$t(
                        'mensagens.menuMapa.iconesFerramentas.cliqueParaDesmarcar'
                    )}`
                );
            } else {
                this.drawMarker.disable();
                $(
                    this.selectorIdMapa +
                    ' .leaflet-interactive.marker-active.marcador'
                ).removeClass('active');
                $(
                    this.selectorIdMapa +
                    ' .leaflet-interactive.marker-active.marcador'
                ).attr(
                    'title',
                    `${this.$t(
                        'mensagens.menuMapa.iconesFerramentas.cliqueParaMarcar'
                    )}`
                );
            }
        },

        closePopup() {
            this.mapa.eachLayer(function (layer) {
                layer.closePopup();
            });
        },

        formatarCamposMarker(
            campo,
            digitos = 7,
            numerosNegativos = true,
            min = null,
            max = null
        ) {
            var element = document.getElementsByName(campo)[0];
            var maskOptions = {
                mask: Number,
                scale: digitos,
                signed: numerosNegativos,
                normalizeZeros: true,
                padFractionalZeros: true,
                radix: '.'
            };

            if (min) {
                maskOptions.min = min;
            }

            if (max) {
                maskOptions.max = max;
            }

            IMask(element, maskOptions);
        },

        selecionarCamadas({ latlng }) {
            this.geometriaAcao = {
                type: 'Point',
                coordinates: [latlng.lng, latlng.lat]
            };

            this.mostrarModalSelecionarCamadas = true;
            setTimeout(() => {
                this.handleModalInspecionarCamadasFullscreen();
            }, 100);
        },

        downloadCamadas(point, camada) {
            const urlDownload =
                URL_KML_DOWNLOAD.url +
                '=' +
                camada +
                '&' +
                URL_KML_DOWNLOAD.output +
                '&cql_filter=CONTAINS(geom, POINT(' +
                point.lng +
                ' ' +
                point.lat +
                '))';
            window.open(urlDownload, '_blank');
        },

        inspecionar(camadasSelecionadas) {
            this.camadasInspecao = camadasSelecionadas;
            this.mostrarModalSelecionarCamadas = false;

            this.mostrarDrawerInspecionar = true;

            const pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            if (this.geometriaAcao.coordinates.length === 2) {
                this.pinIcon = L.marker(
                    [
                        this.geometriaAcao.coordinates[1],
                        this.geometriaAcao.coordinates[0]
                    ],
                    { icon: pinIcon }
                );
                this.mapa.addLayer(this.pinIcon);
            }

            const vm = this;

            let fullscreenAtivado = document.querySelector(
                `${this.selectorIdMapa} [title='${this.$t(
                    'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                )}']`
            );

            if (fullscreenAtivado) {
                $(vm.selectorIdMapa).prepend($('#drawer-inspecionar-camadas'));
            }
        },

        fecharDrawerInspecionar() {
            this.mostrarDrawerInspecionar = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        drawerHistoricoAgricolaFechar() {
            this.mostrarDrawerHistoricoAgricola = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        openCamadaControl() {
            $('.componente-camadas__botao-controle').on(
                'click',
                this.handleControlToggle
            );
            this.mapa.on('click', this.closeCamadaControl);
        },

        closeCamadaControl() {
            if ($('.componente-camadas__container.expandido').length > 0) {
                $('.componente-camadas__botao-controle').trigger('click');
                $('.componente-camadas__container').removeClass('expandido');

                this.handleControlToggle();
            }
        },

        emitEventsTerritorio() {
            EventBus.$emit('mapa:desativar-se-ativo-selecao');
        },

        visualizarAreaMonitoradaSocioambiental(id) {
            this.$router.push({
                name: 'VisualizarMonitoramentoSocioambiental',
                params: { idAreaMonitorada: id }
            });
        },

        formatAreaHa(areaHa) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        addBotaoAnotacoes() {
            L.easyButton({
                id: 'botao-anotacao',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-anotacao',
                        onClick: this.modalAnotacao,
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.adicionarAnotacao'
                        ),
                        icon: 'mdi mdi-comment-text-outline'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoFerramentas() {
            L.easyButton({
                id: 'botao-ferramentas',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-ferramentas',
                        onClick: this.toggleMenuFerramentas,
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.ferramentas'
                        ),
                        icon: 'mdi mdi-wrench-outline mdi-flip-h'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoArea() {
            L.easyButton({
                id: 'botao-area',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-area',
                        onClick: this.toggleMenuArea,
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.area'
                        ),
                        icon: 'mdi mdi-vector-square mdi-flip-h'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoBuscaFinca() {
            L.easyButton({
                id: 'botao-busca-finca',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-busca-finca',
                        onClick: this.toggleMenuBuscaFinca,
                        title: this.$t(
                            'mensagens.menuMapa.iconesFerramentas.pesquisar'
                        ),
                        icon: 'mdi mdi-magnify'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoSentinelHub(cadastroTerritorio) {
            if (!cadastroTerritorio) {
                L.easyButton({
                    id: 'botao-sentinel-hub',
                    position: 'topright',
                    states: [
                        {
                            stateName: 'bloco-sentinel-hub',
                            onClick: this.toggleFerramentasSentinelHub,
                            title: this.$t(
                                'mensagens.menuMapa.iconesFerramentas.imagensSentinel2'
                            ),
                            icon: 'mdi mdi-satellite-variant'
                        }
                    ]
                }).addTo(this.mapa);
            }
        },

        adicionarAnotacao(formDadosAnotacao) {
            this.dadosDaAnotacao = formDadosAnotacao;
            this.emitEventsTerritorio();

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/mdi_comment-text-outline-white.png',
                iconSize: [36, 36]
            });

            this.drawMarkerAnotacao = new L.Draw.Marker(this.mapa, {
                icon: pinIcon,
                draggable: true
            });

            const self = this;

            this.mapa.on(L.Draw.Event.CREATED, event => {
                if (self.dadosDaAnotacao !== null) {
                    const marker = event.layer;

                    const containerPopupAnotacoes =
                        this.criarElementoPopupAnotacoes(self, marker);

                    const customOptions = {
                        maxWidth: 'auto',
                        className: 'customPopup'
                    };

                    var newpopup = L.popup({
                        closeOnClick: false,
                        autoClose: false
                    }).setContent(containerPopupAnotacoes);

                    marker
                        .addTo(self.mapa)
                        .bindPopup(newpopup, customOptions)
                        .openPopup();

                    const closePopupButton = document.querySelector(
                        'a.leaflet-popup-close-button'
                    );
                    let customPopupLast =
                        document.querySelectorAll('.customPopup');
                    let customPopupLastIndex = null;

                    customPopupLast.forEach((item, index) => {
                        customPopupLastIndex = index;
                    });

                    if (
                        document.querySelectorAll('.customPopup')[
                        customPopupLastIndex
                        ]
                    ) {
                        document
                            .querySelectorAll('.customPopup')
                        [customPopupLastIndex].childNodes[0].setAttribute(
                            'style',
                            'padding: 0 !important'
                        );
                        document
                            .querySelectorAll('.customPopup')
                        [
                            customPopupLastIndex
                        ].childNodes[0].childNodes[0].setAttribute(
                            'style',
                            'margin: 0 0 6px 0 !important'
                        );
                        closePopupButton.setAttribute(
                            'style',
                            'margin: 2px 3px 0 0'
                        );
                    }

                    self.dadosDaAnotacao = null;
                }
            });

            if (!this.drawMarkerAnotacao.enabled()) {
                this.drawMarkerAnotacao.enable();
            }
        },

        criarElementoPopupAnotacoes(self, marker) {
            const idPopupAnotacao = uuid.v1();
            self.dadosDaAnotacao.idPopupAnotacao = idPopupAnotacao;

            // Elemento pai
            const containerPopupAnotacoes = document.createElement('div');
            containerPopupAnotacoes.classList.add('pop-up-anotacao');

            // Elemento do texto
            const headerPopupAnotacoes = document.createElement('div');
            headerPopupAnotacoes.classList.add('pop-up-anotacao-header');
            containerPopupAnotacoes.appendChild(headerPopupAnotacoes);

            const headerTitlePopupAnotacoes = document.createElement('h1');
            headerTitlePopupAnotacoes.classList.add(
                'pop-up-anotacao-header-titulo'
            );
            headerTitlePopupAnotacoes.innerText = `${this.$t(
                'mensagens.menuMapa.anotacao'
            )}`;
            headerPopupAnotacoes.appendChild(headerTitlePopupAnotacoes);

            const textoPopupAnotacoes = document.createElement('p');
            textoPopupAnotacoes.setAttribute('id', 'p-' + idPopupAnotacao);
            textoPopupAnotacoes.setAttribute(
                'style',
                `
                                font-size: 12px;
                                color: ${self.dadosDaAnotacao.style.color};
                                font-weight: ${self.dadosDaAnotacao.style.fontWeight};
                                margin: 8px 10px 20px 14px;
                            `
            );
            textoPopupAnotacoes.innerText = self.dadosDaAnotacao.comentario;
            containerPopupAnotacoes.appendChild(textoPopupAnotacoes);

            const breakLinePopupAnotacoes = document.createElement('hr');
            breakLinePopupAnotacoes.classList.add('pop-up-anotacao-breakline');
            containerPopupAnotacoes.appendChild(breakLinePopupAnotacoes);

            // Elemento do botão remover
            const btnPopupAnotacoesRemover = document.createElement('button');
            btnPopupAnotacoesRemover.setAttribute(
                'class',
                'el-button el-button el-button--danger el-button-custom--danger el-button--mini'
            );
            btnPopupAnotacoesRemover.setAttribute('type', 'button');
            btnPopupAnotacoesRemover.setAttribute(
                'style',
                'margin: 6px 28px 5px 8px'
            );
            btnPopupAnotacoesRemover.innerHTML = `   <i class="el-icon-delete"></i> ${this.$t(
                'mensagens.menuMapa.remover'
            )}`;
            btnPopupAnotacoesRemover.href = 'javascript:void(0)';
            btnPopupAnotacoesRemover.onclick = self.removerComentario;
            btnPopupAnotacoesRemover.marker = marker;
            containerPopupAnotacoes.appendChild(btnPopupAnotacoesRemover);

            // Elemento do botão editar
            const btnPopupAnotacoesEditar = document.createElement('button');
            btnPopupAnotacoesEditar.setAttribute('id', idPopupAnotacao);
            btnPopupAnotacoesEditar.setAttribute(
                'class',
                'el-button el-button--primary el-button--mini'
            );
            btnPopupAnotacoesEditar.setAttribute('type', 'button');
            btnPopupAnotacoesEditar.innerHTML = `<i class="el-icon-edit"></i> ${this.$t(
                'mensagens.menuMapa.editar'
            )}`;
            btnPopupAnotacoesEditar.href = 'javascript:void(0)';
            btnPopupAnotacoesEditar.onclick = self.editarComentario;
            btnPopupAnotacoesEditar.dadosDaAnotacao = self.dadosDaAnotacao;
            containerPopupAnotacoes.appendChild(btnPopupAnotacoesEditar);

            return containerPopupAnotacoes;
        },

        editarComentario(e) {
            this.comentarioEmEdicao = true;
            this.dadosDaAnotacaoEdicao = null;
            if (e.target.dadosDaAnotacao) {
                this.toggleMenuFerramentas();
                if (this.ativarMenuFerramentas === true) {
                    this.dadosDaAnotacaoEdicao = JSON.parse(
                        JSON.stringify(e.target.dadosDaAnotacao)
                    );
                    this.comentarioEmEdicao = true;
                } else {
                    this.dadosDaAnotacaoEdicao = null;
                    this.comentarioEmEdicao = false;
                }
            }
        },

        removerComentario(e) {
            if (e.target.marker) {
                this.mapa.removeLayer(e.target.marker);
            }
        },

        aplicarZoomGeoJson(geoJson) {
            this.limparLayerSelecionadaZoom();
            this.limparAreaAgricultavelLayerSelecionadaZoom();
            if (geoJson) {
                if (this.layerSelecionadaZoom) {
                    this.mapa.removeLayer(this.layerSelecionadaZoom);
                }
                this.layerSelecionadaZoom = L.geoJson(geoJson, {
                    style: getEstiloGeometria('restricaoSelecionadaZoom')
                }).addTo(this.mapa);
                this.mapa.fitBounds(this.layerSelecionadaZoom.getBounds());
            } else {
                this.refreshMap();
            }
        },

        aplicarZoomGeoAreaAgricultavel(areaAgricultavel) {
            this.limparLayerSelecionadaZoom();
            this.limparAreaAgricultavelLayerSelecionadaZoom();
            let grupoBounds = [];
            for (let geom of areaAgricultavel) {
                let geojson = L.geoJson(geom.geometriaAreaAgricultavel, {
                    style: mapaEstilos.Geometria.area
                }).addTo(this.mapa);
                this.geometrias.push(geojson);
                grupoBounds.push(geojson.getBounds());
            }
            this.mapa.fitBounds(grupoBounds);
        },

        toggleMenuFerramentas() {
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            if (this.ativarMenuBuscaFinca) {
                this.toggleMenuBuscaFinca();
            }

            if (this.ativarMenuFerramentas === false) {
                this.dadosDaAnotacaoEdicao = null;
                const popupBody = document.querySelector(
                    this.selectorIdMapa +
                    ' .leaflet-popup.leaflet-zoom-animated'
                );
                if (popupBody && document.querySelector('.pop-up-anotacao')) {
                    const closePopupButton = popupBody.querySelector(
                        'a.leaflet-popup-close-button[href="#close"]'
                    );
                    if (closePopupButton && this.comentarioEmEdicao === false) {
                        closePopupButton.click();
                    }
                }
            }

            this.ativarMenuFerramentas = !this.ativarMenuFerramentas;
            this.botaoMenuAtivo(
                this.selectorIdMapa + ' #botao-ferramentas',
                this.ativarMenuFerramentas
            );
            if (this.ativarMenuFerramentas) {
                let fullscreenAtivado = document.querySelector(
                    `${this.selectorIdMapa} [title='${this.$t(
                        'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                    )}']`
                );

                if (fullscreenAtivado) {
                    const vm = this;
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-ferramentas'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-ferramentas')
                            );
                        }
                    }, 200);
                    this.handleModalAnotacaoInputsOnFullscreen();
                }

                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-aberto');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-fechado');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleMenuArea() {
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuFerramentas) {
                this.toggleMenuFerramentas();
            }

            this.ativarMenuArea = !this.ativarMenuArea;
            this.botaoMenuAtivo(
                this.selectorIdMapa + ' #botao-area',
                this.ativarMenuArea
            );
            if (this.ativarMenuArea) {
                let fullscreenAtivado = document.querySelector(
                    `${this.selectorIdMapa} [title='${this.$t(
                        'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                    )}']`
                );

                if (fullscreenAtivado) {
                    const vm = this;
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-area'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-area')
                            );
                        }
                    }, 200);
                }

                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-aberto');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-fechado');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleMenuBuscaFinca() {
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuFerramentas) {
                this.toggleMenuFerramentas();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            this.ativarMenuBuscaFinca = !this.ativarMenuBuscaFinca;
            this.botaoMenuAtivo(
                this.selectorIdMapa + ' #botao-busca-finca',
                this.ativarMenuBuscaFinca
            );
            if (this.ativarMenuBuscaFinca) {
                let fullscreenAtivado = document.querySelector(
                    `${this.selectorIdMapa} [title='${this.$t(
                        'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                    )}']`
                );

                if (fullscreenAtivado) {
                    const vm = this;
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-busca-finca'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-busca-finca')
                            );
                        }
                    }, 200);
                }

                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-aberto');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-fechado');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleMenuCamadas() {
            const vm = this;
            if (this.ativarMenuFerramentas) {
                this.toggleMenuFerramentas();
            }
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            if (this.ativarMenuBuscaFinca) {
                this.toggleMenuBuscaFinca();
            }

            this.ativarMenuCamadas = !this.ativarMenuCamadas;
            this.botaoMenuAtivoCamadas(this.selectorIdMapa + ' #botao-camadas');
            if (this.ativarMenuCamadas) {
                let fullscreenAtivado = document.querySelector(
                    `${this.selectorIdMapa} [title='${this.$t(
                        'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                    )}']`
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-camadas'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-camadas')
                            );
                        }
                    }, 200);
                }

                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-aberto');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-fechado');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleFerramentasSentinelHub() {
            if (this.ativarMenuFerramentas) {
                this.toggleMenuFerramentas();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            if (this.ativarMenuBuscaFinca) {
                this.toggleMenuBuscaFinca();
            }

            this.ativarFerramentasSentinelHub =
                !this.ativarFerramentasSentinelHub;
            this.botaoMenuAtivo(
                this.selectorIdMapa + ' #botao-sentinel-hub',
                this.ativarFerramentasSentinelHub
            );
            if (this.ativarFerramentasSentinelHub) {
                let fullscreenAtivado = document.querySelector(
                    `${this.selectorIdMapa} [title='${this.$t(
                        'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                    )}']`
                );

                if (fullscreenAtivado) {
                    const vm = this;
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#ferramentas-sentinel'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#ferramentas-sentinel')
                            );
                        }
                    }, 200);
                    vm.handleSentinelInputsOnFullscreen();
                }

                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-aberto');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-fechado');
                } else {
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.remove('leaflet-menu-menor-fechado');
                    document
                        .querySelector(this.selectorIdMapa + ' .leaflet-right')
                        .classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        botaoMenuAtivo(seletor, condition) {
            if (condition) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        handleSentinelInputsOnFullscreen() {
            let selectorIdMapa = this.selectorIdMapa;

            setTimeout(() => {
                let datePicker = document.querySelector(
                    selectorIdMapa + ' .el-date-editor'
                );
                datePicker.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        `${selectorIdMapa} [title='${this.$t(
                            'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                        )}']`
                    );
                    let ferramentasSentinelContainer = document.querySelector(
                        selectorIdMapa + ' #ferramentas-sentinel .el-drawer.rtl'
                    );
                    ferramentasSentinelContainer.addEventListener(
                        'click',
                        function () {
                            setTimeout(() => {
                                $(selectorIdMapa + ' .leaflet-top').removeClass(
                                    'fullscreen-ativado'
                                );
                            }, 10);
                        }
                    );
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(
                                selectorIdMapa + ' .ferramentas-sentinel'
                            ).prepend(
                                $('.el-picker-panel.el-date-range-picker')
                            );
                            $(selectorIdMapa + ' .leaflet-top').addClass(
                                'fullscreen-ativado'
                            );
                        }, 20);
                    }
                });
            }, 300);
        },

        handleModalAnotacaoInputsOnFullscreen() {
            let selectorIdMapa = this.selectorIdMapa;

            setTimeout(() => {
                let colorPicker = document.querySelector(
                    selectorIdMapa + ' .el-color-picker__trigger'
                );
                colorPicker.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        `${selectorIdMapa} [title='${this.$t(
                            'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                        )}']`
                    );
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(selectorIdMapa + ' .modal-anotacao').prepend(
                                $('.el-color-dropdown.el-color-picker__panel')
                            );
                        }, 100);
                    }
                });
                let fontTypeSelect = document.querySelector(
                    selectorIdMapa + ' .el-select>.el-input'
                );
                fontTypeSelect.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        `${selectorIdMapa} [title='${this.$t(
                            'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                        )}']`
                    );
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(selectorIdMapa + ' .modal-anotacao').prepend(
                                $('.el-select-dropdown.el-popper')
                            );
                        }, 100);
                    }
                });
            }, 300);
        },

        botaoMenuAtivoCamadas(seletor) {
            if (this.ativarMenuCamadas) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        handleModalInspecionarCamadasFullscreen() {
            let fullscreenAtivado = document.querySelector(
                `${this.selectorIdMapa} [title='${this.$t(
                    'mensagens.menuMapa.iconesFerramentas.sairTelaCheia'
                )}']`
            );

            if (fullscreenAtivado) {
                setTimeout(() => {
                    $(this.selectorIdMapa).prepend(
                        $('.el-dialog__wrapper.modal-selecionar-camadas')
                    );
                    $(this.selectorIdMapa).prepend($('.v-modal'));
                }, 200);
            }
        },

        atualizarListaCamadasModalInspecionar(camadas) {
            this.camadasAtivas = camadas;

            this.camadasInspecao = camadas.map(camada => {
                if (camada) {
                    return camada.codigo;
                }
            });
        },

        adicionarDiagnosticoSocioAmbientalListagem() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t('mensagens.menuSig.infoInserirNovoDiagnostico'),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t(
                                'mensagens.comuns.prosseguir'
                            ),
                            cancelButtonText: this.$t(
                                'mensagens.comuns.voltar'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.setGeometriaDesenhadaAcao(this.geometriaAcao);
                        this.setAcaoEscolhida({
                            acao: TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
                        });
                        this.$emit('diagnostico', this.geometriaAcao);
                    })
                    .catch(() => { });
            } catch (erro) { }
        },

        redirecionarParaDiagnostcosSocioAmbientais() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t('mensagens.menuSig.infoRealizarDiagnostico'),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t(
                                'mensagens.comuns.prosseguir'
                            ),
                            cancelButtonText: this.$t(
                                'mensagens.comuns.voltar'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.setGeometriaDesenhadaAcao(this.geometriaAcao);
                        this.setAcaoEscolhida({
                            acao: TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
                        });
                        this.$router.push({
                            name: 'DiagnosticosSocioambientais'
                        });
                    })
                    .catch(() => { });
            } catch (erro) { }
        }
    }
};
</script>

<style lang="scss">
.leaflet-draw-tooltip {
    min-width: 280px;
    margin-left: 500px;
    padding: 5px;
    font-weight: bold;
    background-color: var(--white);
    color: #565656;

    &:before {
        border-right-color: var(--white);
    }
}

.leaflet-draw-tooltip-subtext {
    color: var(--var(--black)) !important;
    font-weight: bold !important;
}

.popup-deslocado {
    .leaflet-popup {
        margin-left: 1025px;
        margin-bottom: -605px;
        transform: none !important;
    }
}

.leaflet-popup-tip-container {
    display: none;
    position: relative;
}

.leaflet-draw-tooltip {
    margin-left: 20px !important;
    min-width: 165px !important;
}

.leaflet-interactive:focus {
    outline: none !important;
}

.leaflet-top.leaflet-right .mdi:before,
.leaflet-top.leaflet-right .mdi-set {
    font-size: large !important;
}

.leaflet-measure-path-measurement div[title='Total area'] {
    background: var(--white);
    padding: 0.5rem;
    border-radius: 0.5rem;
    min-width: 120px;
}

.leaflet-measure-path-measurement {
    margin-top: -50%;
    margin-left: -20px;
}

.leaflet-measure-path-measurement div[title='Total area']:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--white);
    bottom: -10px;
    right: 90px;
}

.typeahed {
    width: 60vw !important;
}

.el-collapse-item__header {
    height: 35px !important;
    border: 0 !important;
    line-height: initial !important;
    padding: 25px 0px;
}

.el-collapse {
    border: 0 !important;
}

.showLayerRight {
    display: block;
    height: 100%;
    z-index: 2000;
}

.showLayerMain {
    height: 100%;
    min-height: 100vh;
    box-sizing: border-box;
}

.hideLayerRight {
    right: 0px;
}

.hideLayer {
    top: 0px;
    height: 30px;
    margin-top: 10px;
}

.hideLayerMain {
    height: 250px;
}

.leaflet-center {
    left: 50%;
    transform: translate(-50%, 0%);
}

.leaflet-middle {
    top: 50%;
    position: absolute;
    z-index: 1000;
    pointer-events: none;
    transform: translate(0%, -50%);
}

.removerMarcador {
    width: 110px;
}

.leaflet-center.leaflet-middle {
    transform: translate(-50%, -50%);
}

.buffer-container {
    background: transparent;
}

.leaflet-control-buffer {
    width: 100%;
    background: transparent;
    border: none !important;
    text-align: center;
}

.expandido {
    height: 100%;
}

.leaflet-top.leaflet-right {
    overflow-y: auto;
    pointer-events: all;
    padding-left: 8px;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    border-bottom-left-radius: 5px;
    transition: all 0.25s linear;
}

.leaflet-menu-aberto {
    right: 0px;
    transform: translateX(-360px);
}

.leaflet-menu-fechado {
    right: 0px;
    transform: translateX(0px);
}

.leaflet-menu-menor-aberto {
    right: 0px;
    transform: translateX(-247px);
}

.leaflet-menu-menor-fechado {
    right: 0px;
    transform: translateX(0px);
}

#menu-popup-ponto {
    .btn {
        background-color: var(--primary);
        width: 100%;
        min-width: 105px;
        margin-bottom: 4px;
        text-align: left !important;
        height: 24px;

        span {
            font-family: 'Roboto', sans-serif !important;
        }
    }

    .btn:last-of-type {
        background-color: var(--danger);
    }

    .btn:hover {
        background-color: var(--secondary);
    }

    .btn:last-of-type:hover {
        background-color: var(--color-alert);
    }

    .btn::before {
        margin-right: 4px;
    }

    .container-botoes-inspecionar {
        display: flex;
        align-items: center;
        font-size: 12px;
    }
}

.btn-realizar-diagnostico,
.btn-visualizar {
    background-color: var(--primary);
    border-radius: 5px;
    text-align: center;
    color: var(--white);
    padding: 6px;
    font-size: 12px;
    margin-top: 4px;
    cursor: pointer;

    i {
        font-size: 16px;
    }
}

.pop-up-anotacao {
    min-height: 58px;
    min-width: 230px;
    word-break: break-all;
}

.pop-up-anotacao-header {
    height: 33px;
    background-color: var(--light);
    width: 100%;

    .pop-up-anotacao-header-titulo {
        font-size: 14px;
        color: var(--primary);
        margin: 0 0 0 5px;
        padding: 8px;
        font-weight: bold;
    }
}

.pop-up-anotacao-breakline {
    margin-bottom: 1px;
    color: var(--gray);
    border: 1 solid;
}

.anotacao-ativo {
    background-color: var(--$secondary) !important;
}

.el-button-custom--danger {
    background-color: #f56c6c !important;
    color: #fff !important;
}

.el-button-custom--danger:hover {
    background-color: #ec3232 !important;
    color: #fff !important;
}

.leaflet-bar {
    border-radius: 10px;
}

.active {
    background-color: var(--secondary) !important;

    span {
        color: var(--white) !important;
    }
}

.none {
    display: none !important;
}

.fullscreen-ativado {
    z-index: 498 !important;
}

.leaflet-contextmenu,
.leaflet-contextmenu:hover {
    padding-block-start: 15px !important;
    padding-block-end: 15px !important;
    text-align: center !important;
    min-height: 60px !important;
}

.leaflet-contextmenu-item {
    background-color: var(--primary) !important;
    border-radius: 5px !important;
    border: 0px !important;
    text-align: center;
    color: var(--white) !important;
    font-size: 12px;
    margin-top: 4px;
    margin-left: 5%;
    margin-right: 5%;
    cursor: pointer !important;
    height: 30px !important;
    line-height: 28px !important;
    width: auto;
}

.over,
.leaflet-contextmenu-item:hover {
    border: 0px !important;
}

.leaflet-contextmenu-item-disabled {
    background-color: var(--color-button-disabled) !important;
    opacity: 1 !important;
    cursor: default !important;
}

.leaflet-contextmenu-icon {
    margin: 0 3px 0 0 !important;
    background-color: transparent !important;
    float: none !important;
}

#tooltip-download-indisponivel {
    color: white;
    font-size: 12px;
    width: 210px;
    background-color: #303133 !important;
    text-align: left;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: -60%;
    left: -5%;
    margin-left: 0px;
    opacity: 0.95;
    transition: opacity 0.3s;

    p {
        background-color: transparent !important;
        line-height: 15px !important;
        margin: 10px;
        text-align: justify !important;
    }
}

#tooltip-download-indisponivel::after {
    content: '';
    position: absolute;
    top: -13%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #303133 transparent;
}

#tooltip-download-indisponivel:hover {
    visibility: visible;
    opacity: 0.98;
    background-color: #303133 !important;
}
</style>
